import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import WorkOrder from '../../interfaces/WorkOrder.interface';

interface WorkOrdersTableState {
  selectedWorkOrders: WorkOrder[];
}

interface SetSelectedWorkOrdersPayload {
  selectedWorkOrders: WorkOrder[];
}

export const initialState: WorkOrdersTableState = {
  selectedWorkOrders: []
};

const workOrdersTableSlice = createSlice({
  name: 'workOrdersTable',
  initialState,
  reducers: {
    setSelectedWorkOrders(state, action: PayloadAction<SetSelectedWorkOrdersPayload>) {
      state.selectedWorkOrders = action.payload.selectedWorkOrders;
    }
  }
});

export const {
  setSelectedWorkOrders
} = workOrdersTableSlice.actions;

export default workOrdersTableSlice.reducer;
